// frontend/src/lib/appDomain.js
//
// Single source of truth for the public app domain on the frontend.
//
// Motivation: prior code duplicated `import.meta.env.VITE_HOST_DOMAIN || 'stagewise.app'`
// across 7 call sites (Signup, Landing, SuperAdmin x2, TenantDetail, OverviewTab,
// DemoLanding). When the rebrand to Brighella / domain migration to `www.stagewise.eu`
// lands, we want a single file to update.
//
// Precedence:
//   1. VITE_HOST_DOMAIN — the build-time env var. Production sets this.
//   2. VITE_APP_DOMAIN  — alias for forward-compat with audit-doc naming.
//   3. Fallback: 'stagewise.app' (matches the historical hardcoded default).

const FALLBACK_DOMAIN = 'stagewise.app'

export function getAppDomain() {
  const explicit = import.meta.env.VITE_HOST_DOMAIN || import.meta.env.VITE_APP_DOMAIN
  return explicit || FALLBACK_DOMAIN
}

// Helper: build "<slug>.<domain>" display strings for slug previews etc.
export function getTenantDomain(slug) {
  const domain = getAppDomain()
  return slug ? `${slug}.${domain}` : domain
}
